<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M55.5 30.5h-47a1.5 1.5 0 000 3h47a1.5 1.5 0 000-3zM8.5 16h47a1.5 1.5 0 000-3h-47a1.5 1.5 0 000 3zM55.5 48h-47a1.5 1.5 0 000 3h47a1.5 1.5 0 000-3z"/></svg>